import logger from '@widgets/logger';
import { KB, MB, MEDIA_TYPE } from '@constants/file';

export const validateFileSize = (file, max, min) => {
    let error = '';
    let metric = '';
    let size = '';
    if (max && file?.size > max) {
        error = 'file_size_too_large';
        metric = max > MB ? 'MB' : 'KB';
        size = max > MB ? max / MB : max / KB;
    }
    if (min && file?.size < min) {
        error = 'file_size_too_small';
        metric = min > MB ? 'MB' : 'KB';
        size = min > MB ? min / MB : min / KB;
    }
    return { error, metric, size };
};

export const validateFileParams = async (
    mediaType,
    objUrl,
    params = { dimension: [], minDuration: undefined, maxDuration: undefined },
    callback,
) => {
    const { dimension, minDuration, maxDuration } = params;
    const [minWidth, minHeight, maxWidth, maxHeight] = dimension;
    try {
        const media = await (mediaType === MEDIA_TYPE.IMAGE ? loadImage(objUrl) : loadVideo(objUrl));
        const prop = mediaType === MEDIA_TYPE.IMAGE ? ['width', 'height'] : ['videoWidth', 'videoHeight'];
        const width = media[prop[0]];
        const height = media[prop[1]];
        const isHorizontal = width >= height;

        if (
            (minWidth && width < minWidth) ||
            (minHeight && height < minHeight) ||
            (maxWidth &&
                maxHeight &&
                ((isHorizontal && (width > maxWidth || height > maxHeight)) ||
                    (!isHorizontal && (height > maxWidth || width > maxHeight)))) ||
            (maxWidth && !maxHeight && width > maxWidth) ||
            (maxHeight && !maxWidth && height > maxHeight)
        ) {
            callback();
            return { success: false };
        } else if ((minDuration && media.duration < minDuration) || (maxDuration && media.duration >= maxDuration)) {
            callback();
            return { success: false };
        }
        return { success: true };
    } catch (_) {
        logger.error("Couldn't upload media");
        return { success: false };
    }
};

const loadImage = path => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = path;
        img.onload = () => resolve(img);
        img.onerror = e => reject(e);
    });
};

const loadVideo = path => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = path;
        video.preload = 'metadata';

        video.onloadedmetadata = () => {
            resolve(video);
        };

        video.onerror = e => reject(e);
    });
};
